export default __webpack_public_path__ + "static/thumbnails/kh-placeholder-quant.svg";